var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiPropertyOptional } from "@nestjs/swagger";
import { IsDate, IsOptional } from "class-validator";
export class CompositeUpdatedAtDto {
}
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "loginTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "loginText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "welcomeTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "welcomeText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "dataUpdateWelcomeTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "dataUpdateWelcomeText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "californiaBillOfRightsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "californiaBillOfRightsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "studyInformationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "purposeOfResearchTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "lengthOfStudyNumberOfParticipantsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "lengthOfStudyNumberOfParticipantsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "healthRecordUpdatesTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "healthRecordUpdatesText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "proceduresAndInterventionsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "timelineTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "benefitsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "risksTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "voluntaryParticipationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "voluntaryParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "withdrawalImplicationsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "injuryProtocolTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "participationTerminationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "dataTypesTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "sensitiveDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "sensitiveDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "futureUseOfDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "confidentialityMeasuresTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "compensationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "costTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "researchResultsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "whoToContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "whoToContactText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentYesText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentNoText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentInterestedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "hipaaTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "hipaaText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "hipaaOrganizationLegalName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "hipaaAuthorizationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "thankYouConsentedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "thankYouConsentedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "dataUpdateThankYouConsentedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "dataUpdateThankYouConsentedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "thankYouDeclinedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "thankYouDeclinedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "thankYouImInterestedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "thankYouImInterestedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "parentGuardianTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "parentGuardianInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "parentGuardianSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "parentGuardianInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianExemptSignatureText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "minorParticipantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "minorParticipantInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "minorParticipantExemptFromAssentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "minorParticipantAssentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "minorParticipantAssentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "participantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "participantInstructionsForGuidedConsent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "purposeOfResearchText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larParticipantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larParticipantInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larParticipantExemptFromAssentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larParticipantAssentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "larParticipantAssentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "witnessTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "witnessInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "witnessSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "witnessConfirmation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "providerTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "providerInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "providerSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "providerConfirmation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "proceduresAndInterventionsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentPrimaryDiseaseOrConditions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "patientFriendlyTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "patientFriendlySummary", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "informedConsentIRBApprovalStamp", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "risksOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "benefitsOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "leavingStudyEarlyText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "injuryProtocolText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "participationTerminationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "futureUseOfData", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "futureUseOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "confidentialityOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "compensationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "costOfParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "sharingResultsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "alternativesToParticipation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "timelineVisitPeriods", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "timelineVisitDescriptions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "introTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "introPurposeOfDisclosure", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "introBriefEducation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "patientHealthRecordRightsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "contactDetails", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "purposeOfDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "purposeOfDataBriefEducation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "aiToolName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate()
], CompositeUpdatedAtDto.prototype, "aiExplanationOfHealthEx", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "explanationOfDataProtection", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiExplanationOfDataUseByLegalOrg", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiExplanationOfFees", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiAuthToShare", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiAuthToShareExplanation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "timeToConnectInformation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiToolTermsUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiToolIcon", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiChatbotUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional()
], CompositeUpdatedAtDto.prototype, "aiSharingUrl", void 0);
